/* eslint-disable no-undef */
import { createApp } from "vue";
import accordion from "./faq.vue";

const RootApp = {
    components: {
        accordion,
    },
    data() {
        return {
            mobileMenuOpen: false,
            clinicData: {},
            selectedClinic: '',
            activeClinic: 'all',
            teamMemberClinics: {},
        };
    },
    mounted() {
        this.initClinicForm();
        this.initTeamTabs();
    },
    methods: {
        closeMobileMenu() {
            this.mobileMenuOpen = false;
        },
        openMobileMenu() {
            this.mobileMenuOpen = true;
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        initClinicForm() {
            // Parse clinic data from hidden field
            const dataField = document.getElementById('clinic-data');
            if (dataField && dataField.value) {
                try {
                    this.clinicData = JSON.parse(dataField.value);
                } catch (e) {
                    console.warn('Could not parse clinic data');
                }
            }

            // Set up clinic selector listener
            const clinicSelector = document.getElementById('clinic-selector');
            if (clinicSelector) {
                clinicSelector.addEventListener('change', (e) => {
                    this.selectedClinic = e.target.value;
                    this.updateAppointmentOptions();
                });
            }
        },
        updateAppointmentOptions() {
            const appointmentType = document.getElementById('appointment-type');
            if (!appointmentType) return;

            const appearanceOption = appointmentType.querySelector('option[value="Appearance Medicine"]');
            const clinic = this.clinicData[this.selectedClinic];

            if (clinic && !clinic.hasAppearanceMedicine) {
                // Hide/disable Appearance Medicine option
                if (appearanceOption) {
                    appearanceOption.disabled = true;
                    appearanceOption.textContent = 'Appearance Medicine (Not available at this location)';
                }

                // Reset if currently selected
                if (appointmentType.value === 'Appearance Medicine') {
                    appointmentType.value = '';
                }

                // Show explanatory note
                this.showClinicNote('Appearance Medicine services are not yet available at our Queenstown clinic.');
            } else {
                // Re-enable option
                if (appearanceOption) {
                    appearanceOption.disabled = false;
                    appearanceOption.textContent = 'Appearance Medicine';
                }
                this.hideClinicNote();
            }
        },
        showClinicNote(message) {
            const appointmentType = document.getElementById('appointment-type');
            if (!appointmentType) return;

            let note = document.getElementById('clinic-note');
            if (!note) {
                note = document.createElement('div');
                note.id = 'clinic-note';
                note.className = 'clinic-note';
                appointmentType.parentNode.appendChild(note);
            }
            note.textContent = message;
            note.style.display = 'block';
        },
        hideClinicNote() {
            const note = document.getElementById('clinic-note');
            if (note) {
                note.style.display = 'none';
            }
        },
        initTeamTabs() {
            // Parse clinic data from team member elements
            const teamMembers = document.querySelectorAll('.team-block__member[data-clinics]');
            teamMembers.forEach(member => {
                const clinics = member.dataset.clinics;
                const id = member.dataset.memberId || Math.random().toString(36).substr(2, 9);
                member.dataset.memberId = id;
                this.teamMemberClinics[id] = clinics ? clinics.split(',') : [];
            });
        },
        setActiveClinic(clinicId) {
            this.activeClinic = clinicId;
            this.filterTeamMembers();
        },
        memberClinics(memberId) {
            return this.teamMemberClinics[memberId] || [];
        },
        filterTeamMembers() {
            const teamMembers = document.querySelectorAll('.team-block__member[data-clinics]');
            teamMembers.forEach(member => {
                const clinics = member.dataset.clinics ? member.dataset.clinics.split(',') : [];
                if (this.activeClinic === 'all' || clinics.includes(this.activeClinic)) {
                    member.style.display = '';
                } else {
                    member.style.display = 'none';
                }
            });
        },
    },
};

const app = createApp(RootApp);
app.mount("#app");
